import { ContentUserContext } from 'context/3cat/ContentUserProvider';
import { useContext } from 'react';

export const useLaMevaLlista = () => {
    return useContext(ContentUserContext);
};
